export default (selector) => {
  return (state) => {
    return (selector(state) || null)
  }
}